(function(){
'use strict';
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})};
var BB=window.BB||{};
function money(c){
  try{var s=new Intl.NumberFormat(BB.locale||'nl-NL',{style:'currency',currency:BB.cur||'EUR'}).format(c/100);return s.replace(/[,.]00(?!\d)/,'')}
  catch(e){return '€'+(c/100).toFixed(2)}
}
$$('.bb-ann').forEach(function(a){
  var s=$$('span',a);if(!s.length)return;s[0].classList.add('on');if(s.length<2)return;
  var i=0;setInterval(function(){
    var p=s[i];p.classList.remove('on');p.classList.add('out');setTimeout(function(){p.classList.remove('out')},700);
    i=(i+1)%s.length;s[i].classList.add('on');
  },3600);
});
var menu=$('[data-menu]'),mb=$('[data-menu-btn]');
function setMenu(o){
  if(!menu||!mb)return;
  menu.classList.toggle('open',o);menu.setAttribute('aria-hidden',!o);
  mb.textContent=o?mb.getAttribute('data-close'):mb.getAttribute('data-open');
  mb.classList.toggle('is-dark',o);mb.setAttribute('aria-expanded',o);
  document.documentElement.classList.toggle('bb-lock',o);
}
if(mb)mb.addEventListener('click',function(){setMenu(!menu.classList.contains('open'))});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){setMenu(false);setDrawer(false)}});
if(menu){
  var mimg=$('.bb-menu-img img',menu),orig=mimg&&mimg.getAttribute('src');
  $$('.bb-menu-list a',menu).forEach(function(a){
    a.addEventListener('mouseenter',function(){
      $$('.bb-menu-list a',menu).forEach(function(x){x.classList.toggle('act',x===a)});
      var u=a.getAttribute('data-img');if(mimg&&u){mimg.removeAttribute('srcset');mimg.src=u}
    });
  });
  var list=$('.bb-menu-list',menu);
  if(list)list.addEventListener('mouseleave',function(){
    $$('.bb-menu-list a',menu).forEach(function(x){x.classList.remove('act')});
    if(mimg&&orig)mimg.src=orig;
  });
}
var drawer=$('[data-drawer]');
function setDrawer(o){if(!drawer)return;drawer.classList.toggle('open',o);document.documentElement.classList.toggle('bb-lock',o||(menu&&menu.classList.contains('open')))}
function setCount(n){$$('[data-cart-count]').forEach(function(e){e.textContent=n})}
function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
function renderCart(c){
  setCount(c.item_count);
  var list=$('[data-cart-items]'),tot=$('[data-cart-total]'),ft=$('[data-cart-foot]');
  if(tot)tot.textContent=money(c.total_price);
  if(ft)ft.hidden=!c.items.length;
  if(!list)return;
  if(!c.items.length){list.innerHTML='<p class="bb-empty">'+esc(list.getAttribute('data-empty'))+'</p>';return}
  list.innerHTML=c.items.map(function(it){
    var v=(it.variant_title&&it.variant_title!=='Default Title')?'<span>'+esc(it.variant_title)+'</span>':'';
    return '<div class="bb-ci" data-key="'+esc(it.key)+'"><a href="'+esc(it.url)+'" class="im">'+(it.image?'<img src="'+esc(img(it.image,240))+'" alt="">':'')+'</a>'+
      '<div class="tx"><a href="'+esc(it.url)+'"><b>'+esc(it.product_title)+'</b></a>'+v+
      '<div class="q"><button type="button" data-q="'+(it.quantity-1)+'" aria-label="-">−</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" aria-label="+">+</button></div></div>'+
      '<b class="pr">'+money(it.final_line_price)+'</b></div>';
  }).join('');
}
function cartGet(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
function cartPost(url,body){
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
  .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'error');return j})});
}
if(drawer){
  $$('[data-cart-open]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();setMenu(false);setDrawer(true);cartGet().then(renderCart)})});
  $$('[data-drawer-close]',drawer).forEach(function(b){b.addEventListener('click',function(){setDrawer(false)})});
  drawer.addEventListener('click',function(e){
    var b=e.target.closest('[data-q]');if(!b)return;
    var key=b.closest('[data-key]').getAttribute('data-key');
    b.closest('.bb-ci').style.opacity=.4;
    cartPost('/cart/change.js',{id:key,quantity:+b.getAttribute('data-q')}).then(renderCart).catch(function(){cartGet().then(renderCart)});
  });
}
var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('rv-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'}):null;
$$('[data-rv]').forEach(function(el){if(io)io.observe(el);else el.classList.add('rv-in')});
var heroes=$$('[data-hero]');
heroes.forEach(function(h){setTimeout(function(){h.classList.add('in')},80)});
var ticking=false;
function onScroll(){
  ticking=false;
  heroes.forEach(function(h){
    var w=$('.bb-hero-wrap',h),r=h.getBoundingClientRect();
    var p=Math.min(1,Math.max(0,-r.top/(r.height*.9)));
    w.style.transform='scale('+(1-p*.14).toFixed(4)+') rotateX('+(p*12).toFixed(2)+'deg)';
    w.style.opacity=(1-p*.7).toFixed(3);
    w.style.filter=p>0.02?'blur('+(p*6).toFixed(2)+'px)':'';
  });
}
if(heroes.length){window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(onScroll)}},{passive:true});onScroll()}
var SLOTS_M=[[24,20,28],[62,11,24],[80,40,27],[19,55,28],[46,79,27],[80,73,22]];
var SLOTS_D=[[9,26,12],[27,12,11],[46,30,12],[66,13,11],[86,30,12],[15,70,11],[35,82,12],[56,66,11],[76,82,12],[93,66,9]];
function initShop(root){
  var stage=$('[data-stage]',root),items=$$('.bb-fl',stage),pages=$('[data-pages]',root),
      tog=$('[data-grid-toggle]',root),next=$('[data-next]',root),sw=$$('[data-swatches] button',root);
  var page=0,words=null,grid=false,desk=null;
  try{grid=localStorage.getItem('bb-grid')==='1'}catch(e){}
  function vis(){return items.filter(function(i){if(!words)return true;var c=i.getAttribute('data-colors')||'';return words.some(function(w){return w&&c.indexOf(w)>-1})})}
  function layout(){
    desk=window.innerWidth>=900;
    var slots=desk?SLOTS_D:SLOTS_M,v=vis(),per=grid?(desk?20:12):slots.length;
    var n=Math.max(1,Math.ceil(v.length/per));if(page>n-1)page=n-1;
    stage.classList.toggle('grid',grid);
    if(tog){var t=$('span',tog);if(t)t.textContent=grid?tog.getAttribute('data-b'):tog.getAttribute('data-a')}
    items.forEach(function(i){i.hidden=true;i.classList.remove('show')});
    v.slice(page*per,page*per+per).forEach(function(it,k){
      it.hidden=false;
      var s=slots[k%slots.length];
      it.style.setProperty('--x',s[0]+'%');it.style.setProperty('--y',s[1]+'%');it.style.setProperty('--w',s[2]+'%');
      it.style.setProperty('--k',(k*70)+'ms');
      requestAnimationFrame(function(){requestAnimationFrame(function(){it.classList.add('show')})});
    });
    var empty=$('[data-empty]',root);if(empty)empty.hidden=v.length>0;
    if(pages){
      var h='';for(var p=0;p<n;p++)h+='<button type="button" data-p="'+p+'" class="'+(p===page?'on':'')+'">'+(p+1)+'</button>';
      pages.innerHTML=h;
    }
    if(next)next.style.visibility=n>1?'visible':'hidden';
    root.setAttribute('data-n',n);
  }
  function go(d){var n=+root.getAttribute('data-n')||1;page=(page+d+n)%n;layout();}
  if(pages)pages.addEventListener('click',function(e){var b=e.target.closest('[data-p]');if(!b)return;page=+b.getAttribute('data-p');layout()});
  if(next)next.addEventListener('click',function(){go(1)});
  if(tog)tog.addEventListener('click',function(){grid=!grid;page=0;try{localStorage.setItem('bb-grid',grid?'1':'0')}catch(e){}layout()});
  sw.forEach(function(b){b.addEventListener('click',function(){
    var on=b.classList.contains('on');sw.forEach(function(x){x.classList.remove('on')});
    if(on){words=null}else{b.classList.add('on');words=(b.getAttribute('data-words')||'').split(',')}
    page=0;layout();
  })});
  var x0=null,y0=null;
  stage.addEventListener('touchstart',function(e){if(grid)return;x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
  stage.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;x0=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))go(dx<0?1:-1)},{passive:true});
  window.addEventListener('resize',function(){if((window.innerWidth>=900)!==desk)layout()});
  layout();
}
$$('[data-bb-shop]').forEach(initShop);
function initProduct(root){
  var data;try{data=JSON.parse($('[data-pjson]',root).textContent)}catch(e){return}
  var gal=$('[data-gal]',root),slides=$$('.bb-slide',root),count=$('[data-count]',root),idx=0;
  function center(i){var s=slides[i];if(!s)return;gal.scrollTo({left:s.offsetLeft-(gal.clientWidth-s.clientWidth)/2,behavior:'smooth'})}
  function active(){
    var c=gal.scrollLeft+gal.clientWidth/2,best=0,bd=1e9;
    slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft+s.clientWidth/2-c);if(d<bd){bd=d;best=i}});
    idx=best;slides.forEach(function(s,i){s.classList.toggle('on',i===best)});
    if(count)count.textContent=(best+1)+'/'+slides.length;
  }
  if(gal&&slides.length){
    var t=false;gal.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(function(){t=false;active()})}},{passive:true});
    slides.forEach(function(s,i){s.addEventListener('click',function(){if(i!==idx)center(i)})});
    active();
  }
  $$('[data-swipe]',root).forEach(function(b){b.addEventListener('click',function(){center((idx+1)%slides.length)})});
  var back=$('[data-back]',root);
  if(back)back.addEventListener('click',function(e){try{if(document.referrer&&new URL(document.referrer).host===location.host){e.preventDefault();history.back()}}catch(x){}});
  var form=$('[data-atc-form]',root),vid=$('[data-vid]',root),btn=$('[data-atc]',root),price=$('[data-price]',root);
  var cur=data.variants.filter(function(v){return v.id==vid.value})[0]||data.variants[0];
  var sel=cur?cur.options.slice():[];
  var opts=$$('[data-opt]',root);
  function find(s){return data.variants.filter(function(v){return v.options.every(function(o,i){return o===s[i]})})[0]}
  function paint(){
    opts.forEach(function(b){
      var i=+b.getAttribute('data-opt'),val=b.getAttribute('data-val');
      b.classList.toggle('on',sel[i]===val);
      var test=sel.slice();test[i]=val;var v=find(test);
      b.classList.toggle('na',!v||!v.available);
    });
    cur=find(sel);
    if(cur){vid.value=cur.id;if(price)price.textContent=cur.price}
    if(btn){
      var ok=cur&&cur.available;btn.disabled=!ok;
      btn.textContent=!cur?btn.getAttribute('data-na'):(ok?btn.getAttribute('data-add'):btn.getAttribute('data-sold'));
    }
  }
  opts.forEach(function(b){b.addEventListener('click',function(){
    var i=+b.getAttribute('data-opt');sel[i]=b.getAttribute('data-val');paint();
    if(cur){
      try{var u=new URL(location.href);u.searchParams.set('variant',cur.id);history.replaceState(null,'',u)}catch(e){}
      if(cur.media){var k=slides.findIndex(function(s){return s.getAttribute('data-media-id')==cur.media});if(k>-1)center(k)}
    }
  })});
  paint();
  if(form)form.addEventListener('submit',function(e){
    if(!drawer)return;e.preventDefault();
    if(!cur||!cur.available)return;
    btn.disabled=true;btn.textContent=btn.getAttribute('data-adding');
    cartPost('/cart/add.js',{items:[{id:cur.id,quantity:1}]}).then(function(){
      btn.textContent=btn.getAttribute('data-added');btn.classList.add('ok');
      return cartGet().then(function(c){renderCart(c);setDrawer(true)});
    }).catch(function(err){btn.textContent=err.message}).then(function(){
      setTimeout(function(){btn.classList.remove('ok');paint()},1600);
    });
  });
}
$$('[data-bb-product]').forEach(initProduct);
})();